import moment from 'moment';
import React, { Children, useEffect, useState } from 'react';
import { message, Skeleton, Timeline } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CampaignProgressStats } from '../../../../apis/Influencer/Campaigns/CampaignProgressStats';
import { useGlobalState } from '../../../../store/state';
import './CampaignProgressComponent.styles.scss';

const { Item } = Timeline;
const CampaignProgressComponent = ({ campId, name, children }) => {
  const [user] = useGlobalState('user');
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState(true);
  const getProgressStats = () =>{
    CampaignProgressStats(user.accessToken, campId).then(({ status, response })=>{
      console.log('API: Campaign progress ==>', response);
      if (status === 200) {
        setStatus(response.statusTimeline);
        setLoading(false);
      } else {
        message.error('There is some issue with getting progress status');
      }
    });
  };
  useEffect(() =>{
    getProgressStats();
  }, []);
  return loading ?(
    <div className="common_card p-3 camp_progress">
      <Skeleton active
        paragraph={{ rows: 6 }}/>
    </div>
  ):(
    <div className="common_card p-3 camp_progress">
      <h6 className="camp_progress--title"><strong>{name}</strong></h6>
      <div className="camp_progress_timeline">
        <Timeline mode="left">
          {
            status.map(({ _id, status, label, createdAt })=>{
              if (label === 'assigned') {
                return null;
              }
              if (status && label === 'accepted') {
                return (
                  <Item key={_id}
                    dot={status ? <CheckCircleOutlined style={{ fontSize: '16px' }} /> : null}
                    color={`${status ? 'green' : 'grey'}`}>
                    <strong>{label}</strong>
                    <p className="camp_progress_timeline--date">{moment(createdAt).format('Do MMM YYYY hh:mm a')}</p>
                  </Item>
                );
              }
              if (status && label === 'self_reject') {
                return (
                  <Item key={_id}
                    dot={status ? <CheckCircleOutlined style={{ fontSize: '16px' }} /> : null}
                    color={`${status ? 'green' : 'grey'}`}>
                    <strong>{label}</strong>
                    <p className="camp_progress_timeline--date">{moment(createdAt).format('Do MMM YYYY hh:mm a')}</p>
                  </Item>
                );
              }
              if (status && label === 'admin_reject') {
                return (
                  <Item key={_id}
                    dot={status ? <CheckCircleOutlined style={{ fontSize: '16px' }} /> : null}
                    color={`${status ? 'green' : 'grey'}`}>
                    <strong >{label}</strong>
                    <p className="camp_progress_timeline--date">{moment(createdAt).format('Do MMM YYYY hh:mm a')}</p>
                  </Item>
                );
              }
              if (status && label === 'approved') {
                return (
                  <Item key={_id}
                    dot={status ? <CheckCircleOutlined style={{ fontSize: '16px' }} /> : null}
                    color={`${status ? 'green' : 'grey'}`}>
                    <strong>{label}</strong>
                    <p className="camp_progress_timeline--date">{moment(createdAt).format('Do MMM YYYY hh:mm a')}</p>
                  </Item>
                );
              }

              if (label === 'review' || label === 'active' || label === 'closed') {
                return (<Item key={_id}
                  dot={status ? <CheckCircleOutlined style={{ fontSize: '16px' }} /> : null}
                  color={`${status ? 'green' : 'grey'}`}>
                  <strong>{label}</strong>
                  <p className="camp_progress_timeline--date">{moment(createdAt).format('Do MMM YYYY hh:mm a')}</p>
                </Item>);
              }
            })
          }
        </Timeline>
      </div>
      {children}
    </div>
  );
};

export default CampaignProgressComponent;
